function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import React from 'react';
import { Calculation, CalculationTypes, MetricEntryMeasurement } from 'common/query-builder/query-entry-section/types';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { generateCountCalculationMenuOptions } from 'common/query-builder/query-block/count-menu/util';
import { getSelectedCalculation, getSelectedCalculationLabel } from 'common/query-builder/query-entry-section/util';
import { useTranslation } from 'common/i18n/hooks';
import type { RowProps } from '../catalog';

/**
 * Shows controls for a formula's count type: rolling or cumulative options.
 */
export function FormulaMeasurement(props: RowProps) {
  const {
    t,
    print
  } = useTranslation();
  const calculation = getSelectedCalculation(props.entry.measurement || {});
  const handleCalculationSelected = (updatedCalculation: Calculation | null) => {
    const measurement: MetricEntryMeasurement = {};
    if ((updatedCalculation === null || updatedCalculation === void 0 ? void 0 : updatedCalculation.calculationType) === CalculationTypes.Rolling) {
      measurement.rolling = {
        rollingWindowSize: updatedCalculation.rollingWindowSize
      };
      measurement.cumulative = false;
    } else if ((updatedCalculation === null || updatedCalculation === void 0 ? void 0 : updatedCalculation.calculationType) === CalculationTypes.Cumulative) {
      measurement.rolling = null;
      measurement.cumulative = true;
    }
    props.updateEntry(_objectSpread(_objectSpread({}, props.entry), {}, {
      measurement
    }));
  };
  return <SelectReact key='calculation-selector' elref='calculationSelector' label={calculation.calculationType ? print(getSelectedCalculationLabel(calculation, props.sectionProps.dateUnit)) : t("common.standard")} disableSearch menuWidth={180} trackName={props.sectionProps.trackName} theme={SelectTheme.Tertiary} disableTooltip onChange={(ev: CustomEvent) => handleCalculationSelected(ev.detail.item.value)} sections={generateCountCalculationMenuOptions({
    selectedPlotStyle: props.sectionProps.plotStyle,
    selectedCalculation: calculation,
    selectedDateUnit: props.sectionProps.dateUnit,
    includeStandardItem: true
  })} data-sentry-element="SelectReact" data-sentry-component="FormulaMeasurement" data-sentry-source-file="measurement.tsx" />;
}